import React from 'react'
import LogoUsu from '../assets/img/logo_usu.svg'
import Loading from '../assets/img/loading.gif'
import '../style.css'

const LoadingPage = () => {
    return(
      <div className="loader-wrapper">
        <img src={LogoUsu} className="logo-loading" alt="Logo Usu" />
        <img src={Loading} className="loading-indicator" alt="Loading Indicator" />
      </div>
    )
  }

  export default LoadingPage;